var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content ht-100v pd-0"},[_vm._v("dynamic route comp here")])}
var staticRenderFns = []

export { render, staticRenderFns }